import C from '@/utils/rule/constant'
import BaseCalculator from "./BaseCalculator"

class MV extends BaseCalculator {

    /**
     * 胸腰差比
     * @type {number}
     */
    ratio_xy = 0
    /**
     * 胸臀差
     * @type {number}
     */
    ratio_xt = 0

    body = {
        [C.B_JXTZ_ST] : {
            '平肩' : -1,
            '正常' : 0,
            '溜肩' : 1,
        },
        [C.B_TX_C] : {
            '干瘦' : -1,
            '正常' : 0,
            '挺胸' : 1,
        },
        [C.B_TB_B] : {
            '微驼' : 1,
            '正常' : 0,
            '驼背' : 2,
        },
        [C.B_TD_B] : {
            '微凸' : 1,
            '正常' : 0,
            '凸肚' : 2,
        },
    }

    /**
     * 成衣参数key和计算公式
     * @type {{[p: string]: function(*, *, *): *}}
     * 匹配正则 ((base)|(net)|(plus))\[C\.(C|N)([A-Z_])*\]
     */
    complete_size = {
        [C.SOMATOTYPE_A] : {
            [C.PREFERENCE_FITTED] : {
                [C.C_LW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_LW_CL]) + parseFloat(base[C.C_LW_CL]) + parseFloat(plus[C.C_LW_CL])
                },
                [C.C_HYC_BCL] : function (net, base, plus) {
                    return (parseFloat(net[C.N_HZC_BML]) + this.height * 0.4) / 2 + parseFloat(base[C.C_HYC_BCL]) + parseFloat(plus[C.C_HYC_BCL])
                },
                [C.C_JK_SW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW])
                },
                [C.C_XK_CW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - 3.5 + (parseFloat(net[C.N_XK_CW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_BK_BW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - 1 + (parseFloat(net[C.N_BK_BW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_XW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL])
                },
                [C.C_ZY_MW] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL]) + parseFloat(base[C.C_ZY_MW]) + parseFloat(plus[C.C_ZY_MW])
                },
                [C.C_XB_HC] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_XB_HC]) + parseFloat(plus[C.C_XB_HC])
                },
                [C.C_XF_B] : function (net, base, plus) {
                    return parseFloat(net[C.N_SBW_UAL]) + parseFloat(base[C.C_XF_B]) + parseFloat(plus[C.C_XF_B])
                },
            },
            [C.PREFERENCE_NORMAL] : {
                [C.C_LW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_LW_CL]) + parseFloat(base[C.C_LW_CL]) + parseFloat(plus[C.C_LW_CL])
                },
                [C.C_HYC_BCL] : function (net, base, plus) {
                    return (parseFloat(net[C.N_HZC_BML]) + this.height * 0.4) / 2 + parseFloat(base[C.C_HYC_BCL]) + parseFloat(plus[C.C_HYC_BCL])
                },
                [C.C_JK_SW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW])
                },
                [C.C_XK_CW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - 3.5 + (parseFloat(net[C.N_XK_CW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_BK_BW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - 1 + (parseFloat(net[C.N_BK_BW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_XW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL])
                },
                [C.C_ZY_MW] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL]) + parseFloat(base[C.C_ZY_MW]) + parseFloat(plus[C.C_ZY_MW])
                },
                [C.C_XB_HC] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_XB_HC]) + parseFloat(plus[C.C_XB_HC])
                },
                [C.C_XF_B] : function (net, base, plus) {
                    return parseFloat(net[C.N_SBW_UAL]) + parseFloat(base[C.C_XF_B]) + parseFloat(plus[C.C_XF_B])
                },
            },
            [C.PREFERENCE_LOOSE] : {
                [C.C_LW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_LW_CL]) + parseFloat(base[C.C_LW_CL]) + parseFloat(plus[C.C_LW_CL])
                },
                [C.C_HYC_BCL] : function (net, base, plus) {
                    return (parseFloat(net[C.N_HZC_BML]) + this.height * 0.4) / 2 + parseFloat(base[C.C_HYC_BCL]) + parseFloat(plus[C.C_HYC_BCL])
                },
                [C.C_JK_SW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW])
                },
                [C.C_XK_CW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - 3.5 + (parseFloat(net[C.N_XK_CW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_BK_BW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - 1 + (parseFloat(net[C.N_BK_BW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_XW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL])
                },
                [C.C_ZY_MW] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL]) + parseFloat(base[C.C_ZY_MW]) + parseFloat(plus[C.C_ZY_MW])
                },
                [C.C_XB_HC] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_XB_HC]) + parseFloat(plus[C.C_XB_HC])
                },
                [C.C_XF_B] : function (net, base, plus) {
                    return parseFloat(net[C.N_SBW_UAL]) + parseFloat(base[C.C_XF_B]) + parseFloat(plus[C.C_XF_B])
                },
            }
        },
        [C.SOMATOTYPE_B] : {
            [C.PREFERENCE_FITTED] : {
                [C.C_LW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_LW_CL]) + parseFloat(base[C.C_LW_CL]) + parseFloat(plus[C.C_LW_CL])
                },
                [C.C_HYC_BCL] : function (net, base, plus) {
                    return (parseFloat(net[C.N_HZC_BML]) + this.height * 0.4) / 2 + parseFloat(base[C.C_HYC_BCL]) + parseFloat(plus[C.C_HYC_BCL])
                },
                [C.C_JK_SW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW])
                },
                [C.C_XK_CW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - 3.5 + (parseFloat(net[C.N_XK_CW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_BK_BW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - 1 + (parseFloat(net[C.N_BK_BW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_XW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL])
                },
                [C.C_ZY_MW] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL]) + parseFloat(base[C.C_ZY_MW]) + parseFloat(plus[C.C_ZY_MW])
                },
                [C.C_XB_HC] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_XB_HC]) + parseFloat(plus[C.C_XB_HC])
                },
                [C.C_XF_B] : function (net, base, plus) {
                    return parseFloat(net[C.N_SBW_UAL]) + parseFloat(base[C.C_XF_B]) + parseFloat(plus[C.C_XF_B])
                },
            },
            [C.PREFERENCE_NORMAL] : {
                [C.C_LW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_LW_CL]) + parseFloat(base[C.C_LW_CL]) + parseFloat(plus[C.C_LW_CL])
                },
                [C.C_HYC_BCL] : function (net, base, plus) {
                    return (parseFloat(net[C.N_HZC_BML]) + this.height * 0.4) / 2 + parseFloat(base[C.C_HYC_BCL]) + parseFloat(plus[C.C_HYC_BCL])
                },
                [C.C_JK_SW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW])
                },
                [C.C_XK_CW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - 3.5 + (parseFloat(net[C.N_XK_CW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_BK_BW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - 1 + (parseFloat(net[C.N_BK_BW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_XW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL])
                },
                [C.C_ZY_MW] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL]) + parseFloat(base[C.C_ZY_MW]) + parseFloat(plus[C.C_ZY_MW])
                },
                [C.C_XB_HC] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_XB_HC]) + parseFloat(plus[C.C_XB_HC])
                },
                [C.C_XF_B] : function (net, base, plus) {
                    return parseFloat(net[C.N_SBW_UAL]) + parseFloat(base[C.C_XF_B]) + parseFloat(plus[C.C_XF_B])
                },
            },
            [C.PREFERENCE_LOOSE] : {
                [C.C_LW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_LW_CL]) + parseFloat(base[C.C_LW_CL]) + parseFloat(plus[C.C_LW_CL])
                },
                [C.C_HYC_BCL] : function (net, base, plus) {
                    return (parseFloat(net[C.N_HZC_BML]) + this.height * 0.4) / 2 + parseFloat(base[C.C_HYC_BCL]) + parseFloat(plus[C.C_HYC_BCL])
                },
                [C.C_JK_SW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW])
                },
                [C.C_XK_CW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - 3.5 + (parseFloat(net[C.N_XK_CW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_BK_BW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - 1 + (parseFloat(net[C.N_BK_BW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_XW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL])
                },
                [C.C_ZY_MW] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL]) + parseFloat(base[C.C_ZY_MW]) + parseFloat(plus[C.C_ZY_MW])
                },
                [C.C_XB_HC] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_XB_HC]) + parseFloat(plus[C.C_XB_HC])
                },
                [C.C_XF_B] : function (net, base, plus) {
                    return parseFloat(net[C.N_SBW_UAL]) + parseFloat(base[C.C_XF_B]) + parseFloat(plus[C.C_XF_B])
                },
            }
        },
        [C.SOMATOTYPE_C] : {
            [C.PREFERENCE_FITTED] : {
                [C.C_LW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_LW_CL]) + parseFloat(base[C.C_LW_CL]) + parseFloat(plus[C.C_LW_CL])
                },
                [C.C_HYC_BCL] : function (net, base, plus) {
                    return (parseFloat(net[C.N_HZC_BML]) + this.height * 0.4) / 2 + parseFloat(base[C.C_HYC_BCL]) + parseFloat(plus[C.C_HYC_BCL])
                },
                [C.C_JK_SW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW])
                },
                [C.C_XK_CW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - 3 + (parseFloat(net[C.N_XK_CW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_BK_BW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - 1 + (parseFloat(net[C.N_BK_BW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_XW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL])
                },
                [C.C_ZY_MW] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL]) + parseFloat(base[C.C_ZY_MW]) + parseFloat(plus[C.C_ZY_MW])
                },
                [C.C_XB_HC] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_XB_HC]) + parseFloat(plus[C.C_XB_HC])
                },
                [C.C_XF_B] : function (net, base, plus) {
                    return parseFloat(net[C.N_SBW_UAL]) + parseFloat(base[C.C_XF_B]) + parseFloat(plus[C.C_XF_B])
                },
            },
            [C.PREFERENCE_NORMAL] : {
                [C.C_LW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_LW_CL]) + parseFloat(base[C.C_LW_CL]) + parseFloat(plus[C.C_LW_CL])
                },
                [C.C_HYC_BCL] : function (net, base, plus) {
                    return (parseFloat(net[C.N_HZC_BML]) + this.height * 0.4) / 2 + parseFloat(base[C.C_HYC_BCL]) + parseFloat(plus[C.C_HYC_BCL])
                },
                [C.C_JK_SW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW])
                },
                [C.C_XK_CW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - 3 + (parseFloat(net[C.N_XK_CW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_BK_BW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - 1 + (parseFloat(net[C.N_BK_BW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_XW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL])
                },
                [C.C_ZY_MW] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL]) + parseFloat(base[C.C_ZY_MW]) + parseFloat(plus[C.C_ZY_MW])
                },
                [C.C_XB_HC] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_XB_HC]) + parseFloat(plus[C.C_XB_HC])
                },
                [C.C_XF_B] : function (net, base, plus) {
                    return parseFloat(net[C.N_SBW_UAL]) + parseFloat(base[C.C_XF_B]) + parseFloat(plus[C.C_XF_B])
                },
            },
            [C.PREFERENCE_LOOSE] : {
                [C.C_LW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_LW_CL]) + parseFloat(base[C.C_LW_CL]) + parseFloat(plus[C.C_LW_CL])
                },
                [C.C_HYC_BCL] : function (net, base, plus) {
                    return (parseFloat(net[C.N_HZC_BML]) + this.height * 0.4) / 2 + parseFloat(base[C.C_HYC_BCL]) + parseFloat(plus[C.C_HYC_BCL])
                },
                [C.C_JK_SW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW])
                },
                [C.C_XK_CW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - 3 + (parseFloat(net[C.N_XK_CW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_BK_BW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - 1 + (parseFloat(net[C.N_BK_BW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_XW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL])
                },
                [C.C_ZY_MW] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL]) + parseFloat(base[C.C_ZY_MW]) + parseFloat(plus[C.C_ZY_MW])
                },
                [C.C_XB_HC] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_XB_HC]) + parseFloat(plus[C.C_XB_HC])
                },
                [C.C_XF_B] : function (net, base, plus) {
                    return parseFloat(net[C.N_SBW_UAL]) + parseFloat(base[C.C_XF_B]) + parseFloat(plus[C.C_XF_B])
                },
            }
        },
        [C.SOMATOTYPE_D] : {
            [C.PREFERENCE_FITTED] : {
                [C.C_LW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_LW_CL]) + parseFloat(base[C.C_LW_CL]) + parseFloat(plus[C.C_LW_CL])
                },
                [C.C_HYC_BCL] : function (net, base, plus) {
                    return (parseFloat(net[C.N_HZC_BML]) + this.height * 0.4) / 2 + parseFloat(base[C.C_HYC_BCL]) + parseFloat(plus[C.C_HYC_BCL])
                },
                [C.C_JK_SW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW])
                },
                [C.C_XK_CW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - 3 + (parseFloat(net[C.N_XK_CW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_BK_BW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - 1 + (parseFloat(net[C.N_BK_BW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_XW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL])
                },
                [C.C_ZY_MW] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL]) + parseFloat(base[C.C_ZY_MW]) + parseFloat(plus[C.C_ZY_MW])
                },
                [C.C_XB_HC] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_XB_HC]) + parseFloat(plus[C.C_XB_HC])
                },
                [C.C_XF_B] : function (net, base, plus) {
                    return parseFloat(net[C.N_SBW_UAL]) + parseFloat(base[C.C_XF_B]) + parseFloat(plus[C.C_XF_B])
                },
            },
            [C.PREFERENCE_NORMAL] : {
                [C.C_LW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_LW_CL]) + parseFloat(base[C.C_LW_CL]) + parseFloat(plus[C.C_LW_CL])
                },
                [C.C_HYC_BCL] : function (net, base, plus) {
                    return (parseFloat(net[C.N_HZC_BML]) + this.height * 0.4) / 2 + parseFloat(base[C.C_HYC_BCL]) + parseFloat(plus[C.C_HYC_BCL])
                },
                [C.C_JK_SW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW])
                },
                [C.C_XK_CW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - 3 + (parseFloat(net[C.N_XK_CW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_BK_BW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - 1 + (parseFloat(net[C.N_BK_BW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_XW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL])
                },
                [C.C_ZY_MW] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL]) + parseFloat(base[C.C_ZY_MW]) + parseFloat(plus[C.C_ZY_MW])
                },
                [C.C_XB_HC] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_XB_HC]) + parseFloat(plus[C.C_XB_HC])
                },
                [C.C_XF_B] : function (net, base, plus) {
                    return parseFloat(net[C.N_SBW_UAL]) + parseFloat(base[C.C_XF_B]) + parseFloat(plus[C.C_XF_B])
                },
            },
            [C.PREFERENCE_LOOSE] : {
                [C.C_LW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_LW_CL]) + parseFloat(base[C.C_LW_CL]) + parseFloat(plus[C.C_LW_CL])
                },
                [C.C_HYC_BCL] : function (net, base, plus) {
                    return (parseFloat(net[C.N_HZC_BML]) + this.height * 0.4) / 2 + parseFloat(base[C.C_HYC_BCL]) + parseFloat(plus[C.C_HYC_BCL])
                },
                [C.C_JK_SW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW])
                },
                [C.C_XK_CW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - 3 + (parseFloat(net[C.N_XK_CW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_BK_BW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - 1 + (parseFloat(net[C.N_BK_BW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_XW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL])
                },
                [C.C_ZY_MW] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL]) + parseFloat(base[C.C_ZY_MW]) + parseFloat(plus[C.C_ZY_MW])
                },
                [C.C_XB_HC] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_XB_HC]) + parseFloat(plus[C.C_XB_HC])
                },
                [C.C_XF_B] : function (net, base, plus) {
                    return parseFloat(net[C.N_SBW_UAL]) + parseFloat(base[C.C_XF_B]) + parseFloat(plus[C.C_XF_B])
                },
            }
        },
        [C.SOMATOTYPE_Y] : {
            [C.PREFERENCE_FITTED] : {
                [C.C_LW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_LW_CL]) + parseFloat(base[C.C_LW_CL]) + parseFloat(plus[C.C_LW_CL])
                },
                [C.C_HYC_BCL] : function (net, base, plus) {
                    return (parseFloat(net[C.N_HZC_BML]) + this.height * 0.4) / 2 + parseFloat(base[C.C_HYC_BCL]) + parseFloat(plus[C.C_HYC_BCL])
                },
                [C.C_JK_SW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW])
                },
                [C.C_XK_CW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - 3.5 + (parseFloat(net[C.N_XK_CW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_BK_BW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - 1 + (parseFloat(net[C.N_BK_BW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_XW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL])
                },
                [C.C_ZY_MW] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL]) + parseFloat(base[C.C_ZY_MW]) + parseFloat(plus[C.C_ZY_MW])
                },
                [C.C_XB_HC] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_XB_HC]) + parseFloat(plus[C.C_XB_HC])
                },
                [C.C_XF_B] : function (net, base, plus) {
                    return parseFloat(net[C.N_SBW_UAL]) + parseFloat(base[C.C_XF_B]) + parseFloat(plus[C.C_XF_B])
                },
            },
            [C.PREFERENCE_NORMAL] : {
                [C.C_LW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_LW_CL]) + parseFloat(base[C.C_LW_CL]) + parseFloat(plus[C.C_LW_CL])
                },
                [C.C_HYC_BCL] : function (net, base, plus) {
                    return (parseFloat(net[C.N_HZC_BML]) + this.height * 0.4) / 2 + parseFloat(base[C.C_HYC_BCL]) + parseFloat(plus[C.C_HYC_BCL])
                },
                [C.C_JK_SW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW])
                },
                [C.C_XK_CW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - 3.5 + (parseFloat(net[C.N_XK_CW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_BK_BW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - 1 + (parseFloat(net[C.N_BK_BW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_XW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL])
                },
                [C.C_ZY_MW] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL]) + parseFloat(base[C.C_ZY_MW]) + parseFloat(plus[C.C_ZY_MW])
                },
                [C.C_XB_HC] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_XB_HC]) + parseFloat(plus[C.C_XB_HC])
                },
                [C.C_XF_B] : function (net, base, plus) {
                    return parseFloat(net[C.N_SBW_UAL]) + parseFloat(base[C.C_XF_B]) + parseFloat(plus[C.C_XF_B])
                },
            },
            [C.PREFERENCE_LOOSE] : {
                [C.C_LW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_LW_CL]) + parseFloat(base[C.C_LW_CL]) + parseFloat(plus[C.C_LW_CL])
                },
                [C.C_HYC_BCL] : function (net, base, plus) {
                    return (parseFloat(net[C.N_HZC_BML]) + this.height * 0.4) / 2 + parseFloat(base[C.C_HYC_BCL]) + parseFloat(plus[C.C_HYC_BCL])
                },
                [C.C_JK_SW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW])
                },
                [C.C_XK_CW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - 3.5 + (parseFloat(net[C.N_XK_CW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_BK_BW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - 1 + (parseFloat(net[C.N_BK_BW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_XW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL])
                },
                [C.C_ZY_MW] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL]) + parseFloat(base[C.C_ZY_MW]) + parseFloat(plus[C.C_ZY_MW])
                },
                [C.C_XB_HC] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_XB_HC]) + parseFloat(plus[C.C_XB_HC])
                },
                [C.C_XF_B] : function (net, base, plus) {
                    return parseFloat(net[C.N_SBW_UAL]) + parseFloat(base[C.C_XF_B]) + parseFloat(plus[C.C_XF_B])
                },
            }
        },
        [C.SOMATOTYPE_T] : {
            [C.PREFERENCE_FITTED] : {
                [C.C_LW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_LW_CL]) + parseFloat(base[C.C_LW_CL]) + parseFloat(plus[C.C_LW_CL])
                },
                [C.C_HYC_BCL] : function (net, base, plus) {
                    return (parseFloat(net[C.N_HZC_BML]) + this.height * 0.4) / 2 + parseFloat(base[C.C_HYC_BCL]) + parseFloat(plus[C.C_HYC_BCL])
                },
                [C.C_JK_SW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW])
                },
                [C.C_XK_CW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - 2.5 + (parseFloat(net[C.N_XK_CW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_BK_BW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - .5 + (parseFloat(net[C.N_BK_BW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_XW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL])
                },
                [C.C_ZY_MW] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL]) + parseFloat(base[C.C_ZY_MW]) + parseFloat(plus[C.C_ZY_MW])
                },
                [C.C_XB_HC] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_XB_HC]) + parseFloat(plus[C.C_XB_HC])
                },
                [C.C_XF_B] : function (net, base, plus) {
                    return parseFloat(net[C.N_SBW_UAL]) + parseFloat(base[C.C_XF_B]) + parseFloat(plus[C.C_XF_B])
                },
            },
            [C.PREFERENCE_NORMAL] : {
                [C.C_LW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_LW_CL]) + parseFloat(base[C.C_LW_CL]) + parseFloat(plus[C.C_LW_CL])
                },
                [C.C_HYC_BCL] : function (net, base, plus) {
                    return (parseFloat(net[C.N_HZC_BML]) + this.height * 0.4) / 2 + parseFloat(base[C.C_HYC_BCL]) + parseFloat(plus[C.C_HYC_BCL])
                },
                [C.C_JK_SW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW])
                },
                [C.C_XK_CW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - 2.5 + (parseFloat(net[C.N_XK_CW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_BK_BW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - .5 + (parseFloat(net[C.N_BK_BW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_XW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL])
                },
                [C.C_ZY_MW] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL]) + parseFloat(base[C.C_ZY_MW]) + parseFloat(plus[C.C_ZY_MW])
                },
                [C.C_XB_HC] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_XB_HC]) + parseFloat(plus[C.C_XB_HC])
                },
                [C.C_XF_B] : function (net, base, plus) {
                    return parseFloat(net[C.N_SBW_UAL]) + parseFloat(base[C.C_XF_B]) + parseFloat(plus[C.C_XF_B])
                },
            },
            [C.PREFERENCE_LOOSE] : {
                [C.C_LW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_LW_CL]) + parseFloat(base[C.C_LW_CL]) + parseFloat(plus[C.C_LW_CL])
                },
                [C.C_HYC_BCL] : function (net, base, plus) {
                    return (parseFloat(net[C.N_HZC_BML]) + this.height * 0.4) / 2 + parseFloat(base[C.C_HYC_BCL]) + parseFloat(plus[C.C_HYC_BCL])
                },
                [C.C_JK_SW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW])
                },
                [C.C_XK_CW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - 2.5 + (parseFloat(net[C.N_XK_CW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_BK_BW] : function (net, base, plus) {
                    return parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) - .5 + (parseFloat(net[C.N_BK_BW]) - parseFloat(net[C.N_ZJK_SW])) * .25
                },
                [C.C_XW_CL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL])
                },
                [C.C_ZY_MW] : function (net, base, plus) {
                    return parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL]) + parseFloat(base[C.C_ZY_MW]) + parseFloat(plus[C.C_ZY_MW])
                },
                [C.C_XB_HC] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_XB_HC]) + parseFloat(plus[C.C_XB_HC])
                },
                [C.C_XF_B] : function (net, base, plus) {
                    return parseFloat(net[C.N_SBW_UAL]) + parseFloat(base[C.C_XF_B]) + parseFloat(plus[C.C_XF_B])
                },
            }
        },

    }


    /**
     * 覆盖父类方法
     * @param size
     */
    setNetSize(size) {
        super.setNetSize(size)
        // 计算胸腰差比和胸臀差比
        this.ratio_xy = (this.net_size[C.N_ZYW_MWL] / this.net_size[C.N_XW_CL] - 1) * 100
        this.ratio_xt = this.net_size[C.N_XW_CL] - this.net_size[C.N_TW_HL]
    }

    /**
     * 穿衣偏好的加放基础值
     * @param somatotype
     * @param preference
     * @returns {*}
     */
    base(somatotype, preference) {
        let data =  {
            [C.SOMATOTYPE_A] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_LW_CL] : 0,
                    [C.C_HYC_BCL] : 0,
                    [C.C_JK_SW] : -.5,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : -2,
                    [C.C_ZY_MW] : 0,
                    [C.C_XB_HC] : -1,
                    [C.C_XF_B] : -1,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_LW_CL] : .5,
                    [C.C_HYC_BCL] : 0,
                    [C.C_JK_SW] : 0,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : 0,
                    [C.C_ZY_MW] : 0,
                    [C.C_XB_HC] : 1,
                    [C.C_XF_B] : 0,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_LW_CL] : 1,
                    [C.C_HYC_BCL] : 1.5,
                    [C.C_JK_SW] : .5,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : 2,
                    [C.C_ZY_MW] : 0,
                    [C.C_XB_HC] : 3,
                    [C.C_XF_B] : 2,
                }
            },
            [C.SOMATOTYPE_B] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_LW_CL] : 0,
                    [C.C_HYC_BCL] : 0,
                    [C.C_JK_SW] : -.5,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : -2,
                    [C.C_ZY_MW] : 0,
                    [C.C_XB_HC] : -1,
                    [C.C_XF_B] : -1,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_LW_CL] : .5,
                    [C.C_HYC_BCL] : 0,
                    [C.C_JK_SW] : 0,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : 0,
                    [C.C_ZY_MW] : 0,
                    [C.C_XB_HC] : 1,
                    [C.C_XF_B] : 0,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_LW_CL] : 1,
                    [C.C_HYC_BCL] : 1.5,
                    [C.C_JK_SW] : 0.5,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : 2,
                    [C.C_ZY_MW] : 0,
                    [C.C_XB_HC] : 3,
                    [C.C_XF_B] : 2,
                }
            },
            [C.SOMATOTYPE_C] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_LW_CL] : 0,
                    [C.C_HYC_BCL] : 0,
                    [C.C_JK_SW] : -.5,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : -2,
                    [C.C_ZY_MW] : 0,
                    [C.C_XB_HC] : -1,
                    [C.C_XF_B] : -1,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_LW_CL] : .5,
                    [C.C_HYC_BCL] : 0,
                    [C.C_JK_SW] : 0,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : 0,
                    [C.C_ZY_MW] : 0,
                    [C.C_XB_HC] : 1,
                    [C.C_XF_B] : 0,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_LW_CL] : 1,
                    [C.C_HYC_BCL] : 1.5,
                    [C.C_JK_SW] : 0.5,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : 2,
                    [C.C_ZY_MW] : 0,
                    [C.C_XB_HC] : 3,
                    [C.C_XF_B] : 2,
                }
            },
            [C.SOMATOTYPE_D] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_LW_CL] : 0,
                    [C.C_HYC_BCL] : 0,
                    [C.C_JK_SW] : -.5,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : -2,
                    [C.C_ZY_MW] : 0,
                    [C.C_XB_HC] : -1,
                    [C.C_XF_B] : -1,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_LW_CL] : 0,
                    [C.C_HYC_BCL] : 0,
                    [C.C_JK_SW] : 0,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : 0,
                    [C.C_ZY_MW] : 0,
                    [C.C_XB_HC] : 1,
                    [C.C_XF_B] : 0,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_LW_CL] : 1,
                    [C.C_HYC_BCL] : 1.5,
                    [C.C_JK_SW] : 0.5,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : 2,
                    [C.C_ZY_MW] : 0,
                    [C.C_XB_HC] : 3,
                    [C.C_XF_B] : 2,
                }
            },
            [C.SOMATOTYPE_Y] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_LW_CL] : 0,
                    [C.C_HYC_BCL] : 0,
                    [C.C_JK_SW] : -.5,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : -2,
                    [C.C_ZY_MW] : 0,
                    [C.C_XB_HC] : -1,
                    [C.C_XF_B] : -1,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_LW_CL] : .5,
                    [C.C_HYC_BCL] : 0,
                    [C.C_JK_SW] : 0,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : 0,
                    [C.C_ZY_MW] : 0,
                    [C.C_XB_HC] : 1,
                    [C.C_XF_B] : 0,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_LW_CL] : 1,
                    [C.C_HYC_BCL] : 1.5,
                    [C.C_JK_SW] : 0.5,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : 2,
                    [C.C_ZY_MW] : 0,
                    [C.C_XB_HC] : 3,
                    [C.C_XF_B] : 2,
                }
            },
            [C.SOMATOTYPE_T] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_LW_CL] : 0,
                    [C.C_HYC_BCL] : 0,
                    [C.C_JK_SW] : -.5,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : -2,
                    [C.C_ZY_MW] : 0,
                    [C.C_XB_HC] : -1,
                    [C.C_XF_B] : -1,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_LW_CL] : .5,
                    [C.C_HYC_BCL] : 0,
                    [C.C_JK_SW] : 0,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : 0,
                    [C.C_ZY_MW] : 0,
                    [C.C_XB_HC] : 1,
                    [C.C_XF_B] : 0,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_LW_CL] : 1,
                    [C.C_HYC_BCL] : 1.5,
                    [C.C_JK_SW] : 0.5,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : 2,
                    [C.C_ZY_MW] : 0,
                    [C.C_XB_HC] : 3,
                    [C.C_XF_B] : 2,
                }
            },

        }

        return data[somatotype][preference]
    }

    /**
     * 加放量值
     * @param somatotype
     * @param preference
     * @returns {*}
     */
    plus(somatotype, preference) {
        let func_xb = (x) => {
            if(x<=-6) return 4
            else if(x<=-3) return 2
            else if(x<=0) return 0
            else return -2
        }
        let data =  {
            [C.SOMATOTYPE_A] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_LW_CL] : 6,
                    [C.C_HYC_BCL] : -3,
                    [C.C_JK_SW] : -.5,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : 16,
                    [C.C_ZY_MW] : this.ratio_xy * 0.5 + .5,
                    [C.C_XB_HC] : 2,
                    [C.C_XF_B] : 12,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_LW_CL] : 6,
                    [C.C_HYC_BCL] : -3,
                    [C.C_JK_SW] : -.5,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : 16,
                    [C.C_ZY_MW] : this.ratio_xy * 0.5 + .5,
                    [C.C_XB_HC] : 2,
                    [C.C_XF_B] : 12,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_LW_CL] : 6,
                    [C.C_HYC_BCL] : -3,
                    [C.C_JK_SW] : -.5,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : 16,
                    [C.C_ZY_MW] : this.ratio_xy * 0.5 + .5,
                    [C.C_XB_HC] : 2,
                    [C.C_XF_B] : 12,
                }
            },
            [C.SOMATOTYPE_B] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_LW_CL] : 6,
                    [C.C_HYC_BCL] : -3,
                    [C.C_JK_SW] : -1,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : 15,
                    [C.C_ZY_MW] : this.ratio_xy * 0.5 + .5,
                    [C.C_XB_HC] : 1,
                    [C.C_XF_B] : 12,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_LW_CL] : 6,
                    [C.C_HYC_BCL] : -3,
                    [C.C_JK_SW] : -1,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : 15,
                    [C.C_ZY_MW] : this.ratio_xy * 0.5 + .5,
                    [C.C_XB_HC] : 1,
                    [C.C_XF_B] : 12,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_LW_CL] : 6,
                    [C.C_HYC_BCL] : -3,
                    [C.C_JK_SW] : -1,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : 15,
                    [C.C_ZY_MW] : this.ratio_xy * 0.5 + .5,
                    [C.C_XB_HC] : 1,
                    [C.C_XF_B] : 12,
                }
            },
            [C.SOMATOTYPE_C] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_LW_CL] : 6,
                    [C.C_HYC_BCL] : -2,
                    [C.C_JK_SW] : -1,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : 13,
                    [C.C_ZY_MW] : this.ratio_xy * 0.5 - .5,
                    [C.C_XB_HC] : 1,
                    [C.C_XF_B] : 11,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_LW_CL] : 6,
                    [C.C_HYC_BCL] : -2,
                    [C.C_JK_SW] : -1,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : 13,
                    [C.C_ZY_MW] : this.ratio_xy * 0.5 - .5,
                    [C.C_XB_HC] : 1,
                    [C.C_XF_B] : 11,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_LW_CL] : 6,
                    [C.C_HYC_BCL] : -2,
                    [C.C_JK_SW] : -1,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : 13,
                    [C.C_ZY_MW] : this.ratio_xy * 0.5 - .5,
                    [C.C_XB_HC] : 1,
                    [C.C_XF_B] : 11,
                }
            },
            [C.SOMATOTYPE_D] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_LW_CL] : 6,
                    [C.C_HYC_BCL] : -1,
                    [C.C_JK_SW] : -.5,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : 14,
                    [C.C_ZY_MW] : this.ratio_xy * 0.5 - .5,
                    [C.C_XB_HC] : 1,
                    [C.C_XF_B] : 10,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_LW_CL] : 6,
                    [C.C_HYC_BCL] : -1,
                    [C.C_JK_SW] : -.5,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : 14,
                    [C.C_ZY_MW] : this.ratio_xy * 0.5 - .5,
                    [C.C_XB_HC] : 1,
                    [C.C_XF_B] : 10,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_LW_CL] : 6,
                    [C.C_HYC_BCL] : -1,
                    [C.C_JK_SW] : -.5,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : 14,
                    [C.C_ZY_MW] : this.ratio_xy * 0.5 - .5,
                    [C.C_XB_HC] : 1,
                    [C.C_XF_B] : 10,
                }
            },
            [C.SOMATOTYPE_Y] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_LW_CL] : 6,
                    [C.C_HYC_BCL] : -3,
                    [C.C_JK_SW] : -1,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : 18,
                    [C.C_ZY_MW] : this.ratio_xy * 0.5 + .5,
                    [C.C_XB_HC] : 2,
                    [C.C_XF_B] : 13,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_LW_CL] : 6,
                    [C.C_HYC_BCL] : -3,
                    [C.C_JK_SW] : -1,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : 18,
                    [C.C_ZY_MW] : this.ratio_xy * 0.5 + .5,
                    [C.C_XB_HC] : 2,
                    [C.C_XF_B] : 13,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_LW_CL] : 6,
                    [C.C_HYC_BCL] : -3,
                    [C.C_JK_SW] : -1,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : 18,
                    [C.C_ZY_MW] : this.ratio_xy * 0.5 + .5,
                    [C.C_XB_HC] : 2,
                    [C.C_XF_B] : 13,
                }
            },
            [C.SOMATOTYPE_T] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_LW_CL] : 6,
                    [C.C_HYC_BCL] : -2,
                    [C.C_JK_SW] : -1,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : 10,
                    [C.C_ZY_MW] : this.ratio_xy * 0.5 - 1,
                    [C.C_XB_HC] : 4,
                    [C.C_XF_B] : 10,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_LW_CL] : 6,
                    [C.C_HYC_BCL] : -2,
                    [C.C_JK_SW] : -1,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : 10,
                    [C.C_ZY_MW] : this.ratio_xy * 0.5 - 1,
                    [C.C_XB_HC] : 4,
                    [C.C_XF_B] : 10,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_LW_CL] : 6,
                    [C.C_HYC_BCL] : -2,
                    [C.C_JK_SW] : -1,
                    [C.C_XK_CW] : 0,
                    [C.C_BK_BW] : 0,
                    [C.C_XW_CL] : 10,
                    [C.C_ZY_MW] : this.ratio_xy * 0.5 - 1,
                    [C.C_XB_HC] : 4,
                    [C.C_XF_B] : 10,
                }
            },

        }

        return data[somatotype][preference]
    }


    /**
     * 计算成衣尺寸
     * @param preference
     * @returns {{}}
     */
    getCompleteSize(preference) {
        this.preference = preference
        let somatotype = this.custom_somatotype || this.default_somatotype
        let base_size = this.base(somatotype , this.preference)
        let plus_size = this.plus(somatotype, this.preference)
        let formulas = this.complete_size[somatotype][this.preference];

        let result = {}
        for(let key in formulas) {
            let temp = Math.round(formulas[key].apply(this, [this.net_size, base_size, plus_size, result]) * 10) / 10
            result[key] = isNaN(temp) ? 0 : temp
        }


        if(C.SOMATOTYPE_A == somatotype && this.net_size[C.N_XW_CL] < 88) {
            result[C.C_HYC_BCL] = Math.round((result[C.C_XW_CL] + .5) * 10) / 10
        }

        return result
    }

    getBodySize() {
        let result = {}
        for(let key in this.body_size) {
            if (key in this.body) result[key] = this.body[key][this.body_size[key]] || 0

        }

        return result
    }
}

export default MV
